export default defineNuxtRouteMiddleware((to, from) => {
  const userStore = useUserStore();

  if (to.query.organization && userStore.isLoggedIn) {
    const organization = to.query.organization;
    return `/${organization}/`;
  }

  if (!userStore.isLoggedIn) {
    return "/signin";
  }
});
